import Vue from "vue";
import CompanyService from "@/service/CompanyService";
import MenuRightSerivce from "@/service/MenuRightService";
import SweetAlertService from "@/service/SweetAlertService";
import StaffService from "@/service/StaffService";
import StoreGetter from "@/constants/StoreGetter";
import { Relationship } from "@/model/Relationship";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import Setting from "@/constants/Settings";
import RelationshipValidation from "./S081400-RelationshipValidation.js";
import Paginate from "vuejs-paginate";
var RelationshipValidationObj = new RelationshipValidation();
export default {
    name: "Relationship",
    mounted() {
        RelationshipValidationObj.RelationshipValidation();
        this.assignRights();
        this.getAllRelationship();
    },
    components: {
        paginate: Paginate,
    },
    data: () => ({
        menuRights: { allRights: {}, rightsForThisMenu: {} },
        menuId: Setting.MenuID.S_Relationship,
        dictEnum: dictEnum,
        Relationship: new Relationship(),
        isEditMode: false,
        RelationshipList: [],
        selectAllRelationship: false,
        tempRelationshipModel: new Relationship(),
    }),
    computed: {
        t() {
            return t;
        },
        user() {
            return this.$store.getters[StoreGetter.user];
        },
    },
    methods: {
        hasRight(key, menuId) {
            if (Object.keys(this.menuRights.allRights).length === 0) {
                return false;
            } else {
                return MenuRightSerivce.hasRightInMenu(
                    this.menuRights.allRights,
                    menuId ? menuId : this.menuId,
                    key
                );
            }
        },
        assignRights() {
            this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];
            this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
                x => x.MenuID == this.menuId
            );
        },
        async getAllRelationship() {
            var self = this;
            var obj = {}
            const response = await StaffService.getAllRelationship(obj);
            if (response.data.IsSuccess) {
                self.RelationshipList = response.data.Data;
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },
        selectAllRelationshipRecord: function () {
            var self = this;
            var IsSelected = self.selectAllRelationship;
            self.RelationshipList.forEach(function (val, index) {
                val["isSelected"] = IsSelected;
            });
        },
        deleteMultipleRelationshipPopup: function () {
            var arrayList = [];
            var self = this;
            self.RelationshipList.forEach(function (key, value) {
                if (key.isSelected) {
                    arrayList.push(key);
                }
            });
            if (arrayList.length > 0) {
                $('#deleteRelationshipListModel').modal('show');
            }
            else {
                SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectDeleteRecord));
            }
        },
        async deleteMultipleRelationship() {
            var arrayList = [];
            var self = this;
            $('#deleteRelationshipListModel').modal('hide');
            self.RelationshipList.forEach(function (key, value) {
                if (key.isSelected) {
                    arrayList.push(key);
                }
            });
            const obj = {
                relationshipList: arrayList,
            };
            const response = await StaffService.deleteRelationship(obj);
            if (response.data.IsSuccess) {
                SweetAlertService.success("Success", response.data.Message);
                self.resetRelationship();
                await self.getAllRelationship();
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },
        OnRelationshipSelect: function (model) {
            this.tempRelationshipModel = model;
        },
        addRelationship: function () {
            var self = this;
            $('#RelationshipModel').modal('show');
            self.isEditMode = false;
            self.Relationship = new Relationship();
            self.$validator.reset();
            self.vErrors.clear();
        },
        async saveRelationshipDetail(obj) {
            var self = this;
            const response = await StaffService.addRelationship(obj);
            if (response.data.IsSuccess) {
                SweetAlertService.success("Success", response.data.Message);
                self.resetRelationship();
                await self.getAllRelationship();
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },
        async editRelationship(obj) {
            var self = this;
            const response = await StaffService.updateRelationship(obj);
            if (response.data.IsSuccess) {
                SweetAlertService.success("Success", response.data.Message);
                self.resetRelationship();
                await self.getAllRelationship();
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },
        async saveRelationship() {
            var self = this;
            self.$validator.validateAll().then(result => {
                if (result) {
                    $('#RelationshipModel').modal('hide');
                    const obj = {
                        model: {
                            RelateType: self.Relationship.RelateType,
                            CDesc: self.Relationship.CDesc,
                            EDesc: self.Relationship.EDesc,
                        }
                    };
                    if (self.isEditMode) {
                        self.editRelationship(obj);
                    }
                    else {
                        self.saveRelationshipDetail(obj);
                    }
                }
            });
        },
        async editRelationshipDetail() {
            var self = this;
            self.isEditMode = true;
            if (self.tempRelationshipModel.RelateType != "") {
                self.Relationship = this.tempRelationshipModel;
                self.$validator.reset();
                self.vErrors.clear();
                $('#RelationshipModel').modal('show');
            }
            else {
                SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectEditRecord));
            }
        },
        resetRelationship: function () {
            var self = this;
            self.selectAllRelationship = false;
            self.isEditMode = false;
            self.Relationship = new Relationship();
            self.tempRelationshipModel = new Relationship();
            self.$validator.reset();
            self.vErrors.clear();
        },
        closeRelationshipPopup: function () {
            var self = this;
            self.selectAllRelationship = false;
            self.isEditMode = false;
            self.Relationship = new Relationship();
            self.tempRelationshipModel = new Relationship();
            self.$validator.reset();
            self.vErrors.clear();
            $('#RelationshipModel').modal('hide');
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/S080000-Setup/S081400-Relationship/S081400-Relationship.js